var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9454 34.0696L33.3441 30.6692C33.8673 30.1398 34.49 29.719 35.1764 29.4321C35.8631 29.1453 36.5995 28.9978 37.3434 28.9978C38.0876 28.9978 38.8241 29.1453 39.5107 29.4321C40.1971 29.719 40.8199 30.1398 41.3427 30.6692L45.3292 34.6576C45.8585 35.1806 46.2789 35.8031 46.5656 36.4901C46.8523 37.1767 47 37.914 47 38.6582C47 39.4027 46.8523 40.1397 46.5656 40.8266C46.2789 41.5133 45.8585 42.1358 45.3292 42.6589L43.5149 44.4995C42.2647 45.7624 40.6479 46.5984 38.8949 46.8876C37.1418 47.1767 35.3423 46.9049 33.753 46.1104C20.077 39.0675 8.93769 27.9325 1.88654 14.2568C1.09162 12.6652 0.821708 10.8624 1.11559 9.10762C1.40946 7.35284 2.252 5.73633 3.52209 4.49083L5.33636 2.65024C6.39925 1.59333 7.83703 1 9.33565 1C10.8343 1 12.272 1.59333 13.3349 2.65024L17.347 6.66407C18.4035 7.72742 18.9965 9.1656 18.9965 10.6648C18.9965 12.1641 18.4035 13.6023 17.347 14.6656L13.9482 18.0659C16.1955 21.1069 18.664 23.9776 21.3335 26.6553C23.9876 29.315 26.841 31.7682 29.8687 33.9929L29.9454 34.0696Z",
    stroke: "#000064",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTel);
export default __webpack_public_path__ + "static/media/ic-tel.7380b68d1be499e8c7ce3b7df9aa7256.svg";
export { ForwardRef as ReactComponent };